import "./App.css";
import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import Login from "./Pages/AuthPages/Login/Login";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Snackbar from "./Components/SnackbarComponents/Snackbar";
import { AdminInterFace } from "./Components/FeedComponents/Feed/Feed";
import ForgotPassword from "./Pages/AuthPages/ForgotPassword/ForgotPassword";
import ResetPassword from "./Pages/AuthPages/ResetPassword/ResetPassword";
import ResetPasswordInitial from "./Pages/AuthPages/ResetPasswordInitial/ResetPasswordInitial";
import FreezeMasjids from "./Pages/DetailPages/FreezeMasjids/FreezeMasjids";
import FreezeAdmins from "./Pages/DetailPages/FreezeAdmins/FreezeAdmins";
import Masjids from "./Pages/DetailPages/Masjids/Masjids";
import Announcement from "./Pages/DetailPages/Announcement/Announcement";
import Hadith from "./Pages/DetailPages/Hadith/Hadith";
import QuranVerses from "./Pages/DetailPages/QuranVerses/QuranVerses";
import AdminProfile from "./Pages/ProfilePages/AdminProfile/AdminProfile";
import Common_App from "./Common/Common_App";
import CRM from "./Components/CRMComponent/CRM";
// import Menu from "./Components/MenuPage/Menu";
import VerificationCenter from "./Pages/DetailPages/VerificationCenter/VerificationCenter";
import DonationLinkReview from "./Pages/DetailPages/DonationLinkReview/DonationLinkReview";

import InternalAdmins from "./Pages/DetailPages/Admins/InternalAdmins/InternalAdmins";
import ExternalAdmins from "./Pages/DetailPages/Admins/ExternalAdmins/ExternalAdmins";
import Organizations from "./Pages/DetailPages/Organizations/Organizations";
import Individuals from "./Pages/DetailPages/Individuals/Individuals";
import Archives from "./Pages/DetailPages/Archives/Archives";
import EndUsers from "./Pages/DetailPages/EndUsers/EndUsers";
import TailwindTest from "./Components/TailwindTest";
import { GoogleMapsLoaderProvider } from "./contexts/GoogleMapsLoaderContext";

function App() {
  const adminString = localStorage.getItem("admin");
  const admin: AdminInterFace | null = adminString
    ? JSON.parse(adminString)
    : null;
  const routes = [
    {
      path: "/",
      element: <Dashboard />,
      protected: true,
    },
    {
      path: "*",
      element: <Dashboard />,
      protected: true,
    },

    {
      path: "/masjids",
      element: <Masjids />,
      protected: true,
    },
    {
      path: "/crm",
      element: <CRM />,
      protected: true,
    },
    {
      path: "/reset-password/:token",
      element: <ResetPassword />,
      protected: false,
    },
    {
      path: "/forgotpassword",
      element: <ForgotPassword />,
      protected: false,
    },
    {
      path: "/account/initial",
      element: <ResetPasswordInitial />,
      protected: false,
    },
    {
      path: "/freezeMasjids",
      element: <FreezeMasjids />,
      protected: true,
    },
    {
      path: "/announcements",
      element: <Announcement />,
      protected: true,
    },
    {
      path: "/hadith",
      element: <Hadith />,
      protected: true,
    },
    {
      path: "/quran-verses",
      element: <QuranVerses />,
      protected: true,
    },

    {
      path: "/freezeAdmins",
      element: <FreezeAdmins />,
      protected: true,
    },
    {
      path: "/archives",
      element: <Archives />,
      protected: true,
    },
    {
      path: "/end-users",
      element: <EndUsers />,
      protected: true,
    },
    {
      path: "/internal-admins",
      element: <InternalAdmins />,
      protected: true,
    },
    {
      path: "/external-admins",
      element: <ExternalAdmins />,
      protected: true,
    },
    {
      path: "/organizations",
      element: <Organizations />,
      protected: true,
    },
    {
      path: "/individuals",
      element: <Individuals />,
      protected: true,
    },
    {
      path: "/verification-center",
      element: <VerificationCenter />,
      protected: true,
    },
    {
      path: "/donation-link-review",
      element: <DonationLinkReview />,
      protected: true,
    },
    {
      path: "/admins/:adminId",
      element: <AdminProfile />,
      protected: true,
    },
    // {
    //   path: "/feed/:tab",
    //   element: <MenuWrapperVanilla />,
    //   protected: true,
    // },

    // {
    //   path: "/add-tv/:id",
    //   element: <AddTvVanilla />,
    //   protected: true,
    // },
    {
      path: "/TailwindTest",
      element: <TailwindTest />,
      protected: true,
    },
    {
      path: "/login",
      element: admin ? (
        admin.role === "superadmin" || admin.role === "admin" ? (
          <Navigate to="/" />
        ) : (
          <Login />
        )
      ) : (
        <Login />
      ),
    },
  ];

  return (
    <GoogleMapsLoaderProvider>
      <Snackbar />
      <Common_App routes={routes} />
    </GoogleMapsLoaderProvider>
  );
}

export default App;
